(function () {
  function removeFromCookie(items, id) {
    const itemIndex = items.map(function (item) { return JSON.parse(item).id; }).indexOf(id);

    if (itemIndex >= 0) {
      items.splice(itemIndex, 1);
      const cookie = ["pendingSaveItem", '=', JSON.stringify(items), '; domain=.', window.location.host.toString(), '; path=/;'].join('');
      document.cookie = cookie;
    }

    return itemIndex >= 0;
  }

  function saveToFavorites() {
    const pendingItems = document.cookie.match(new RegExp("pendingSaveItem=([^;]+)"));
    const favoriteItems = pendingItems ? JSON.parse(pendingItems[1]) : [];

    for (let index = favoriteItems.length - 1; index >= 0; index -= 1) {
      const favoriteString = favoriteItems[index];
      const favoriteObject = JSON.parse(favoriteString);
      const data = {
        Type: favoriteObject.type,
        Id: favoriteObject.id,
        FavoriteUrl: favoriteObject.url,
        Title: favoriteObject.name
      };

      handleSaveFavorites(data, favoriteObject, favoriteItems);
    }
  }

  function handleSaveFavorites(data, favoriteObject, favoriteItems) {
    fetch("/favorites/save", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
    .then(function (resp) {
      if (!resp.ok) {
        return null;
      }
      return resp.json().catch(() => null);
    })
    .then(function (resp) {
      if (!resp || !resp.Saved || !resp.Id) {
        return;
      }

      // Select all elements showing the same item using data-builder.
      // This ensures every visual instance of the favorited item gets the assigned favorite record id and updated styling.
      const targetContainers = document.querySelectorAll("[data-favorite-container-builder-id='" + favoriteObject.id + "']");
      for (const container of targetContainers) {
        const savedAnchor = container.querySelector('[data-favorite-unsave]');
        const unsaveAnchor = container.querySelector('[data-favorite-save]');

        if (savedAnchor) {
          savedAnchor.style.display = 'block';
          savedAnchor.dataset.favid = resp.Id;
        }
        if (unsaveAnchor) {
          unsaveAnchor.style.display = 'none';
        }
      }

      removeFromCookie(favoriteItems, favoriteObject.id);
    });
  }

  const pendingItems = document.cookie.match(new RegExp("pendingSaveItem=([^;]+)"));
  const cookieFavorites = pendingItems ? JSON.parse(pendingItems[1]) : [];
  const isLoggedIn = document.querySelector('[data-isloggedin="True"]');

  if (cookieFavorites.length === 0) {
    return;
  }

  if (isLoggedIn) {
    saveToFavorites();
  }

  document.addEventListener("updateSavesWhenLoggedIn", saveToFavorites);
}());